<div *ngIf="pageError?.fciErrorType === FciErrorType.emptyContent" class="error-bg-wrapper">
	<div class="error-message-wrapper">
		<error-content [mistake]="pageError"></error-content>
	</div>
</div>

<ng-template #errorModalTemplate>
	<div
		class="calloutDomContent"
		(modalOnClose)="clear()"
		(modal)="errorModalHandler($event)"
	>
		<div class="error-message-wrapper">
			<error-content [mistake]="pageError"></error-content>
		</div>
	</div>
</ng-template>


<ng-container [cdkPortalOutlet]="selectedPortal"></ng-container>
